// UploadSettingsService.ts

import type { ISoftwareSettingsRepository } from "@domain/repositories";
import { SettingsTypeEnumSchema, SoftwareEnumSchema, SoftwareSettingsMetadata } from "@domain/schemas/BI";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";

@injectable()
class UploadSettingsService {
  @inject(TYPES.ISoftwareSettingsRepository)
  private _settingsRepository!: ISoftwareSettingsRepository;

  async uploadSettingsAsync(
    file: File,
    softwareVersion: string,
    onProgress: (progress: number) => void,
    settingsType: SettingsTypeEnumSchema,
    software?: SoftwareEnumSchema,
  ): Promise<SoftwareSettingsMetadata> {
    return this._settingsRepository.createAsync(file, softwareVersion, settingsType, onProgress, software);
  }
}

export { UploadSettingsService };
